module.exports = __webpack_public_path__ + "img/morning_study2_sm.91177090.png";